module.exports = __webpack_public_path__ + "static/img/01.e3fc8263.jpg";